import { memo } from 'react';

import { type PublicClip } from '@air/api';
import { ClipStatus } from '@air/api/types';
import { ImgixImage } from '@air/component-imgix-image';

import { AssetGalleryCardFailedTranscode } from '~/components/Gallery/AssetGalleryCard/AssetGalleryCardFailedTranscode';
import { AssetGalleryCardProcessing } from '~/components/Gallery/AssetGalleryCard/AssetGalleryCardProcessing';
import { getCloudFrontUrlFromImgixUrl } from '~/constants/cloudfront';
import { getClipImageAlt } from '~/utils/getClipImageAlt';

export type ContentCollectionGalleryAssetThumbnailProps = {
  clip: PublicClip;
};

export const ContentCollectionGalleryAssetThumbnail = memo(({ clip }: ContentCollectionGalleryAssetThumbnailProps) => {
  if ([ClipStatus.failed, ClipStatus.nonTranscodable].includes(clip.status)) {
    return <AssetGalleryCardFailedTranscode className="size-full" ext={clip.ext} />;
  }

  if (!clip.assets.image) {
    return <AssetGalleryCardProcessing className="size-full" ext={clip.ext} />;
  }

  return (
    <ImgixImage
      alt={getClipImageAlt(clip, 'displayTitle')}
      fallbackUrl={getCloudFrontUrlFromImgixUrl(clip.assets.image)}
      height={240}
      imgixParams={{
        fit: 'clip',
        cs: 'origin',
      }}
      src={clip.assets.image}
    />
  );
});

ContentCollectionGalleryAssetThumbnail.displayName = 'ContentCollectionGalleryAssetThumbnail';
